import {
    GET_SALE_INVOICE_LIST_PROGRESS, GET_SALE_INVOICE_LIST_SUCCESS, GET_SALE_INVOICE_LIST_FAILURE,
    ADD_SALE_INVOICE_PROGRESS, ADD_SALE_INVOICE_SUCCESS, ADD_SALE_INVOICE_FAILURE,
    EDIT_DELETE_SALE_INVOICE_PROGRESS, EDIT_DELETE_SALE_INVOICE_SUCCESS, EDIT_DELETE_SALE_INVOICE_FAILURE,

    RESET_MESSAGE,
    GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS,
    GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE,
    GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
    GET_AGE_OF_UNPAID_INVOICE_SUCCESS,
    GET_AGE_OF_UNPAID_INVOICE_FAILURE,
    GET_AGE_OF_UNPAID_INVOICE_PROGRESS,

} from '../../types/actionTypes';

const initialState = {
    saleInvoice: [],
    lastEntryNo: null,
    sales_itemDescription_forManualEntry: [],
    ageOf_unpaid_invoice: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const sales_invoice_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SALE_INVOICE_LIST_SUCCESS:
            return { ...state, saleInvoice: action.saleInvoice, lastEntryNo: action.saleInvoice[0].invoiceNo, loading: false };
        case GET_SALE_INVOICE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SALE_INVOICE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_SALE_INVOICE_PROGRESS:
            return { ...state, loading: true };
        case ADD_SALE_INVOICE_SUCCESS:
            return { ...state, saleInvoice: [...state.saleInvoice, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_SALE_INVOICE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_SALE_INVOICE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_SALE_INVOICE_SUCCESS:
            return {
                ...state,
                saleInvoice: state.saleInvoice.map((saleInvoice) =>
                    saleInvoice.id === action.payload.id ? action.payload : saleInvoice
                ),
                message: action.payload.message
            };

        case EDIT_DELETE_SALE_INVOICE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS:
            return { ...state, sales_itemDescription_forManualEntry: action.sales_itemDescription_forManualEntry, loading: false };
        case GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS:
            return { ...state, loading: true, error: false };

        case GET_AGE_OF_UNPAID_INVOICE_SUCCESS:
            return { ...state, ageOf_unpaid_invoice: action.ageOf_unpaid_invoice, loading: false };
        case GET_AGE_OF_UNPAID_INVOICE_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_AGE_OF_UNPAID_INVOICE_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default sales_invoice_reducer;